import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {SpecialistSizesValuesService} from './specialist-sizes-values.service';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class SpecialistSizesValuesProvider extends BaseProvider<SpecialistSizes> {
    constructor(
        service: SpecialistSizesValuesService
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения для размеров спецодежды (по сути соблюдаем формат, чтобы потом ему соответствовать)
         */
        this.data$.next({
            clothing_size: [],
            glove_size: [],
            headgear_size: [],
            pants_size: [],
            shoe_size: [],
        });
        this.updateData();
    }
}

interface SpecialistSizes {
    clothing_size: SelectValueInterface[];
    glove_size: SelectValueInterface[];
    headgear_size: SelectValueInterface[];
    pants_size: SelectValueInterface[];
    shoe_size: SelectValueInterface[];
}
